var map = {
	"./Avatar_1.png": 7758,
	"./Avatar_10.png": 1126,
	"./Avatar_2.png": 2092,
	"./Avatar_3.png": 228,
	"./Avatar_4.png": 3828,
	"./Avatar_5.png": 2497,
	"./Avatar_6.png": 2696,
	"./Avatar_7.png": 2253,
	"./Avatar_8.png": 4669,
	"./Avatar_9.png": 321
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6714;